import { render, staticRenderFns } from "./FormTemplateBoolQuestion.vue?vue&type=template&id=2fba20eb&scoped=true&"
import script from "./FormTemplateBoolQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateBoolQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba20eb",
  null
  
)

export default component.exports